<template>
  <v-menu offset-y nudge-left="290" :close-on-content-click="false">
    <template #activator="{ on }">
      <div class="reminder-icon" v-on="on">
        <v-badge v-if="hasUnviewed" overlap color="error">
          <template #badge>
            <span>{{ unviewedBadge }}</span>
          </template>
          <app-icon color="white" class="pr-4">alarm</app-icon>
        </v-badge>
        <app-icon v-else color="white">alarm</app-icon>
      </div>
    </template>
    <v-card class="reminder-container">
      <v-card-title class="subtitle-1 font-weight-medium">
        <v-container class="py-0">
          <v-row>
            <v-col class="col-auto mr-auto pa-0"><span>Reminders</span></v-col>
            <v-col class="col-auto pa-0"
              ><a v-if="hasReminders" class="viper-link" @click="clearAll()">Clear All</a>
              <span v-else class="clear-all__disabled">Clear All</span>
            </v-col>
          </v-row>
        </v-container>
      </v-card-title>
      <v-card-text class="pa-0">
        <v-list class="pt-0">
          <div v-if="hasReminders">
            <v-list-item v-for="reminder of orderedReminders" :key="reminder.id" class="pa-0">
              <component
                :is="getComponent(reminder)"
                :notification="reminder"
                @update="getReminders(true)"
              ></component>
            </v-list-item>
          </div>
          <v-list-item v-else>
            <span>You have no reminders. Have a great day!</span>
          </v-list-item>
        </v-list>
      </v-card-text>
    </v-card>
  </v-menu>
</template>

<script>
import { reminderService } from '@/services/reminder-service'
import TrialPatientReminderNotification from '@/components/trials/TrialPatientReminderNotification'
import moment from 'moment'
import _ from 'lodash'

export default {
  components: { TrialPatientReminderNotification },
  data() {
    return {
      reminders: [],
      interval: null
    }
  },
  computed: {
    orderedReminders() {
      return _.orderBy(this.reminders, ['reminderTimestamp', 'id'], 'desc')
    },
    hasReminders() {
      return !_.isEmpty(this.reminders)
    },
    hasUnviewed() {
      return !_.isEmpty(_.filter(this.reminders, it => !it.viewed))
    },
    unviewedBadge() {
      const unviewedCount = _.filter(this.reminders, it => !it.viewed).length
      if (unviewedCount < 9) {
        return unviewedCount
      }
      return '9+'
    }
  },
  created() {
    this.getReminders(true)
    this.interval = setInterval(this.getReminders, 60000)
  },
  destroyed() {
    clearInterval(this.interval)
  },
  methods: {
    async setViewed(requests) {
      await reminderService.setViewed(requests)
    },
    getComponent(reminder) {
      return `${_.kebabCase(reminder.reminderType)}-reminder-notification`
    },
    async getReminders(requestNow) {
      if (moment().minute() === 0 || requestNow) {
        const { data } = await reminderService.getReminders()
        this.reminders = data
      }
    },
    async clearAll() {
      const requestList = _.map(this.reminders, it => {
        return { id: it.id }
      })
      await reminderService.setRead(requestList)
      this.getReminders(true)
    }
  }
}
</script>

<style lang="scss" scoped>
.reminder-icon {
  width: 100%;
  height: 100%;
  cursor: pointer;
}
.reminder-container {
  max-height: 95vh;
}
.clear-all__disabled {
  color: var(--v-mediumTwo-base);
}
</style>
